export const sprintsConstants = {
    errors: {
        fetchFailed: "Failed to load sprints.",
        fetchDetailFailed: "Failed to load sprint details.",
        createFailed: "Failed to create sprint.",
        updateFailed: "Failed to update sprint.",
        deleteFailed: "Failed to delete sprint.",
        activateFailed: "Failed to activate sprint.",
        summaryFailed: "Failed to load sprint summary.",
    },
    messages: {
        createSuccess: "Sprint created successfully.",
        updateSuccess: "Sprint updated successfully.",
        deleteSuccess: "Sprint deleted successfully.",
        activateSuccess: "Sprint activated successfully.",
    },
};
